import { WIcon } from '@alice-health/wonderland-react'
import { WIconComponentProps } from '@alice-health/wonderland'
import { ClassName } from '@/types'

interface WIconWrapperProps extends WIconComponentProps {
  className?: ClassName
  title?: string
}
export const WIconWrapper = ({ ...props }: WIconWrapperProps) => {
  return <WIcon {...props} />
}
